import { useState } from 'react';

/**
 * Custom hook to manage all modal states in TaskManagement component
 * Consolidates 9 modal states and their setters into a single hook
 */
export const useTaskModals = () => {
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEnhancedViewModal, setShowEnhancedViewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showCreateSubtaskModal, setShowCreateSubtaskModal] = useState(false);
    const [showCommentsModal, setShowCommentsModal] = useState(false);
    const [showApprovalModal, setShowApprovalModal] = useState(false);
    const [showVerifyModal, setShowVerifyModal] = useState(false);
    const [showReassignModal, setShowReassignModal] = useState(false);
    const [showUserSlideOver, setShowUserSlideOver] = useState(false);

    return {
        showCreateModal,
        setShowCreateModal,
        showEnhancedViewModal,
        setShowEnhancedViewModal,
        showEditModal,
        setShowEditModal,
        showCreateSubtaskModal,
        setShowCreateSubtaskModal,
        showCommentsModal,
        setShowCommentsModal,
        showApprovalModal,
        setShowApprovalModal,
        showVerifyModal,
        setShowVerifyModal,
        showReassignModal,
        setShowReassignModal,
        showUserSlideOver,
        setShowUserSlideOver
    };
};
